import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { Card, CardBody, CardHeader, Input, Label, Spinner } from "reactstrap";
import { MDBDataTableV5 } from "mdbreact";
import Swal from "sweetalert2";
import axios from "axios";
import { BASE_URL } from "../utils/constants";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
} from "chart.js";

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Title);

const examLink = "";

let labelExams = [],
  examsGraph = [
    {
      label: "Percentage (max - 100%)",
      data: [],
      fill: false,
      backgroundColor: "rgba(54, 162, 235, 0.4)",
      borderColor: "rgba(54, 162, 235, 1)",
    },
  ],
  crsGrdedExs = [];

const Performance = () => {
  const [dataExams, setDataExams] = useState({
      labels: labelExams,
      datasets: [],
    }),
    optionsExams = {
      responsive: true,
      scales: {
        y: {
          beginAtZero: true,
        },
      },
      plugins: {
        title: {
          display: true,
          text: "Assessment Performance Chart",
        },
      },
    },
    [selectedCourse, setSelectedCourse] = useState(""),
    [examsData, setExamssData] = useState({
      columns: [
        {
          label: "#",
          field: "id",
        },
        {
          label: "Deadline",
          field: "ddate",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Course Name",
          field: "course",
        },
        {
          label: "Go To",
          field: "go",
        },
      ],
      rows: [
        {
          id: <Spinner color="info" />,
          ddate: <Spinner color="info" />,
          status: <Spinner color="info" />,
          course: <Spinner color="info" />,
          go: <></>,
        },
      ],
    }),
    [gradedExams, setGradedExams] = useState([]),
    [courses, setCourses] = useState([]),
    [isLoading, setIsLoading] = useState(false);

  const getSchGrades = (originArr) => {
    let grdsArr = [];
    let cIndex = 0;
    originArr.forEach((section) => {
      const catArray = section["grading_category"];
      section["period"].forEach((period) => {
        period["assignment"].forEach((ass) => {
          cIndex = catArray.findIndex((gc) => gc.id == ass.category_id);
          ass["category"] =
            cIndex != -1 ? catArray[cIndex].title : "Assessment";
          grdsArr.push(ass);
        });
      });
    });
    return grdsArr;
  };

  useEffect(async () => {
    try {
      Swal.showLoading();
      let res = await axios.get(`${BASE_URL}/exam/getallexams.php`);

      await setCourses(res.data.data.courses);

      res.data.data.courses.forEach((course) => {
        let assPortalExams = [],
          schExams = [],
          qzArray = res.data.data.quizez.filter(
            (exam) =>
              exam.subject_id == course.id &&
              (exam.status == "Graded" || exam.status == "Missed")
          ),
          hmArray = res.data.data.homeworks.filter(
            (exam) =>
              exam.subject_id == course.id &&
              (exam.status == "Graded" || exam.status == "Missed")
          ),
          examsFromSch = course.sectionsArray;

        if (qzArray.length > 0 && hmArray.length > 0) {
          assPortalExams = qzArray.concat(hmArray);
        } else if (qzArray.length > 0) {
          assPortalExams = qzArray;
        } else {
          assPortalExams = hmArray;
        }

        assPortalExams.forEach((exam) => {
          let ArrayGraded = JSON.parse(exam.answerdquestions);
          let ArrayQuestions = JSON.parse(exam.questions);
          let score =
            exam.status == "Graded"
              ? ArrayGraded.reduce((total, obj) => +obj.score + total, 0)
              : 0;
          let totalMark = ArrayQuestions.reduce(
            (total, obj) => +obj.totalMark + total,
            0
          );
          crsGrdedExs.push({
            id: course.id,
            name: course.name,
            examname: exam.examname,
            score: score,
            totalMark: totalMark,
          });
        });

        if (getSchGrades(examsFromSch).length > 0) {
          schExams = getSchGrades(examsFromSch);
          schExams.forEach((grade) => {
            if (grade.grade != null) {
              const d = new Date(grade.timestamp * 1000).toLocaleDateString();
              crsGrdedExs.push({
                id: course.id,
                name: course.name,
                examname: grade.category + "\n" + d,
                score: grade.grade,
                totalMark: grade.max_points,
              });
            }
          });
        }
      });

      await setGradedExams(crsGrdedExs);

      handleSelectCourse(
        { target: { value: res.data.data.courses[0]?.name } },
        crsGrdedExs
      );

      crsGrdedExs = [];

      // set home works datatable
      setExamssData((prevState) => {
        const newState = { ...prevState };
        let ser = 1;
        // change .exams below to .homeworks after backend finished
        let newRows = res.data.data.quizez.map((quiz, key) => {
          return {
            ...quiz,
            id: ser++,
            ddate: quiz.enddate,
            status: quiz.status,
            course: quiz.coursename,
            go: (
              <>
                {quiz.status == "Graded" ? (
                  <a
                    href={quiz.examlink}
                    target="_blank"
                    className="btn btn-primary text-center fs-6 fw-bold py-1 px-3"
                  >
                    Preview
                  </a>
                ) : quiz.status == "Pending" ? (
                  <a
                    href=""
                    className="btn btn-primary text-center fs-6 fw-bold py-1 px-3"
                  >
                    Take exam
                  </a>
                ) : (
                  ""
                )}
              </>
            ),
          };
        });

        let newRows2 = res.data.data.homeworks.map((quiz, key) => {
          return {
            ...quiz,
            id: ser++,
            ddate: quiz.enddate,
            status: quiz.status,
            course: quiz.coursename,
            go: (
              <>
                {quiz.status == "Graded" ? (
                  <a
                    href={quiz.examlink}
                    target="_blank"
                    className="btn btn-primary text-center fs-6 fw-bold py-1 px-3"
                  >
                    Preview
                  </a>
                ) : quiz.status == "Pending" ? (
                  <a
                    href=""
                    className="btn btn-primary text-center fs-6 fw-bold py-1 px-3"
                  >
                    Take exam
                  </a>
                ) : (
                  ""
                )}
              </>
            ),
          };
        });
        return { ...newState, rows: newRows.concat(newRows2) };
      });
      Swal.close();
    } catch {
      Swal.fire("Error while grapping exams!", "", "error");
    }
  }, []);

  // Handle select course for performance chart
  const handleSelectCourse = (e, t) => {
    
    const value = e.target.value;
    setIsLoading(true);
    setSelectedCourse(value);
    const courseExams =
      gradedExams.length > 0
        ? gradedExams.filter((exam) => exam.name == value)
        : t.filter((exam) => exam.name == value);
    labelExams = [];
    examsGraph[0].data = [];
    courseExams.forEach((cExam) => {
      labelExams.push(cExam.examname);
      examsGraph[0].data.push((cExam.score / cExam.totalMark) * 100);
    });
    setDataExams({ labels: [...labelExams], datasets: [...examsGraph] });
    
  };
 

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <div className="header mt-5">
          <h3 className="title">Performance</h3>
        </div>
        <div className="row justify-content-center my-5">
          <div className="col-10 exams mb-5 m-lg-0 shadow-lg bg-body rounded mx-auto">
            <Label
              htmlFor="quiz"
              className="text-center fs-5 fw-bold text-primary"
            >
              Select Course to show performance
            </Label>
            <Input
              id="quiz"
              className="my-3 fs-6 fw-bold"
              type="select"
              value={selectedCourse}
              name="quiz"
              onChange={(e) => handleSelectCourse(e)}
            >
              {/* <option disabled value="">Select Course</option> */}
              {courses.map((course, key) => {
                return (
                  <option default key={key} value={course.name}>
                    {course.name}
                  </option>
                );
              })}
            </Input>
            {isLoading && (
              <Line
                data={dataExams}
                options={optionsExams}
                style={{ maxHeight: "60vh" }}
              />
            )}
          </div>
        </div>
        <hr />
        <div className="row justify-content-between mx-0 my-5 linkssec">
          <div className="col-12 exams shadow-lg bg-body rounded mb-5 m-lg-0">
            <div className="examsdiv">
              <Card>
                <CardHeader className="fs-5 fw-bold bg-info pb-3 text-dark">
                  IVY Assessments
                </CardHeader>
                <hr />
                <CardBody className="bg-light">
                  <MDBDataTableV5
                    hover
                    responsive
                    borderless={false}
                    bordered
                    striped
                    entriesOptions={[5, 20, 25]}
                    entries={5}
                    pagesAmount={4}
                    data={examsData}
                    fullPagination
                    searchTop
                    searchBottom={false}
                  />
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Performance;
